.progressWrap {
  margin: 1rem 0;
}

.progress {
  width: 100%;
  appearance: none;
  height: 0.5rem;
  border: none;
  border-radius: 9999px;
  background-color: var(--color-muted);
  overflow: hidden;
}

/* Firefox */
.progress::-moz-progress-bar {
  background-color: var(--color-primary);
  border-radius: 9999px;
}

/* Chrome, Safari, Edge */
.progress::-webkit-progress-bar {
  background-color: var(--color-muted);
  border-radius: 9999px;
}

.progress::-webkit-progress-value {
  background-color: var(--color-primary);
  border-radius: 9999px;
}
